import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Row, Col } from '@cleartrip/bento/lib';
import Image from '../../../components/Image';
import MediaRatios from './img/media-ratios.png';
import MediaBaseline from './img/media-baseline.jpg';
import MediaCard from './img/media-card.png';
import MediaGrid from './img/media-grid.png';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "media"
    }}>{`Media`}</h1>
    <p>{`Standardized sizes for media objects`}</p>
    <p>{`Instead of using arbitatry sizes, we reccomend a few aspect ratios to define the width/height of any kind of media object on the page. This could be an image, video, gif, icons, etc.`}</p>
    <p>{`The aspect ratios are usually written in the format of `}<inlineCode parentName="p">{`width:height`}</inlineCode></p>
    <h2 {...{
      "id": "ratios"
    }}>{`Ratios`}</h2>
    <p>{`We use and recommend the following ratios:-`}</p>
    <Image src={MediaRatios} mdxType="Image" />
    <h2 {...{
      "id": "baseline"
    }}>{`Baseline`}</h2>
    <p>{`Make sure that the height of the media object is in multiples of 4. This will ensure that the objects aligns perfectly with our baseline.`}</p>
    <img src={MediaBaseline} width="50%" style={{
      margin: 0
    }} />
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <Row className="mt-10 mb-15" mdxType="Row">
  <Col span={24} mdxType="Col">
    <img src={MediaGrid} />
  </Col>
  <Col span={24} className="mt-3" mdxType="Col">
    <span className="fs-body-2 lh-copy mb-2 d-block">
      An example of an image grid with each media item falling within the constraints of the <code>1:1</code> ratio.
    </span>
  </Col>
    </Row>
    <Row className="my-10" mdxType="Row">
  <Col mdxType="Col">
    <img src={MediaCard} />
  </Col>
  <Col offset={1} mdxType="Col">
    <span className="fs-body-2 lh-copy mb-2 d-block">
      The image on the card has a ratio of <code>3:4</code>.
    </span>
    <br />
    <span className="fs-body-2 lh-copy d-block">
      For slightly taller images the <code>3:2</code> or the <code>3:4</code> ratio could be used as well.
    </span>
  </Col>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      